<template>
  <base-button
    class="text-sm p-3 rounded-xs flex gap-2 ring ring-grey-30 items-center between"
    :class="{ 'bg-grey-90': modelValue && unavailable }"
    @click="$emit('click')"
  >
    <span class="grow line-clamp-1" :class="{ 'c-grey-20': !modelValue }">
      <!-- @slot Slot for label -->
      <slot />
    </span>
    <vf-icon dir="down" name="chevron" size="md" />
  </base-button>
</template>

<script lang="ts" setup>
defineProps<{
  /**
   * Unavailable means the variant is out of stock, it will appear disabled but remain selectable
   */
  unavailable?: boolean
}>()

defineEmits<{
  click: []
}>()

const modelValue = defineModel<string>()
</script>
